<style  scoped>
#Layer_1
{
  z-index: 10000000;
}
#appstart
{
  width: 100vw;
}
#appstart:after
{
    content: "";
    position: fixed;
    top: 0;
    left: 0;
    font-size: 0;
    font-family: Blender Pro;
}

body
{
  -webkit-text-size-adjust: 100%;
    -ms-text-size-adjust: 100%;
    text-size-adjust: 100%;
}


.logo{
	position: absolute;
	top: 15%;
	left: 65%;
	width: 250px;
	/*height: 41px;*/
	margin-top: -20px;
	opacity: 0;
	transition: opacity .8s;
	will-change: opacity
}

@media (max-width:1599px)
 {
   .content {
     right: 100px;
     left: 60%;
      }
}

@media (max-width:1199px)
{
  .content
  {
      right: 70px;
  }
}

@media (max-width:767px)
{
  .content
  {
      position: relative;
      top: auto;
      right: auto;
      bottom: auto;
      left: auto;
      padding-top: 45vh;
      padding-left: 50px;
      padding-right: 50px;
  }
}

.logo.is-visible {
	opacity: 1
}

.canvas
 {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
}
.page-home
{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}

.page{
    opacity: 1;
    transition: opacity .3s;
}

.gradient-top
{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 140px;
    background-image: linear-gradient(180deg,rgba(5,7,15,.5),rgba(5,7,15,0));
    pointer-events: none;
}

.gradient-bottom{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 140px;
    background-image: linear-gradient(0deg,rgba(5,7,15,.7),rgba(5,7,15,0));
    pointer-events: none;
}

.top-background
 {
    display: none;
    position: fixed;
    right: 0;
    top: 0;
    left: 0;
    height: 75px;
    background: #0f0f18;
    transition: opacity .3s;
    opacity: 0;
    z-index: 2;
}

.loader{
    position: absolute;
    top: 50%;
    width: 200px;
    right: 0;
    opacity: 0;
    transition: opacity .5s .5s;
    will-change: opacity;
}

.content {
    display: -ms-flexbox;
    display: flex;
    position: absolute;
    top: 0;
    right: 200px;
    bottom: 0;
    left: 65%;
    -ms-flex-direction: column;
    flex-direction: column;
    -ms-flex-pack: center;
    justify-content: center;
    padding-top: 20px;
}
.title
{
    font-size: 20px;
    font-size:calc(50px + 22 * (50vw + 50vh - 2000px) /2000);
    font-family: 'Aquawax light';
    font-style: normal;
    font-weight: normal;
    text-transform: uppercase;
    line-height: 1.2em;
    letter-spacing: .1em;
    margin-bottom: 1em;
    color: #1d1d1b;
}


@media (max-width:1800px) {
	.title {
		font-size: 40px;
		line-height: 1.1em;
		margin-bottom: .5em
	}
}



@media (max-width:1023px) {
	.title {
		font-size: 30px;
    font-size:calc(30px + 22 * (50vw + 50vh - 2000px) /2000)
	}
}
@media (max-width:1199px) {
	.title {
		line-height: 1em;
		font-size: 28px;
      font-size:calc(39px + 22 * (50vw + 50vh - 2000px) /2000)
	}
}
@media (max-width:767px) {
  .title {
	  	line-height: 1em;
		  font-size: 17px;
      font-size:calc(33px + 22 * (50vw + 50vh - 2000px) /2000)
	}
}

@media (max-width:579px)
{

  .title {
	  padding-left: 1%;
	}
}



.main-logo {
	display: inline-block;
	position: fixed;
	bottom: 40px;
	left: 50px;
	height: 41px;
	width: 128px;
	opacity: 1;
	transition: opacity .3s;
	z-index: 2
}



@media (max-width:1023px) {
	.main-logo {
		bottom: 18px;
		left: 30px
	}
}

@media (max-width:579px) {
	.main-logo {
		top: 15px;
		bottom: auto
	}
}

.main-logo.v-enter,
.main-logo.v-leave-to {
	opacity: 0
}

.langs{
	display: inline-block;
	vertical-align: middle
}

@media (max-width:579px)
{
	.langs{
		display: -ms-flexbox;
		display: flex;
		height: 100%
	}
}

.langs .lang{
	opacity: 1
}





.langs .lang:not(:last-child):after {
	content: ".";
	display: inline-block;
	margin-left: 8px;
	margin-right: 8px;
	color: #8e8e8e
}


@media (max-width:579px)
{

	.langs .lang
  {
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: center;
		justify-content: center;
		-ms-flex-align: center;
		align-items: center;
		height: 100%;
		padding-left: 20px;
		padding-right: 20px;
		border-right: 1px solid hsla(0, 0%, 100%, .05)
	}
  .langs .lang:not(:last-child):after
  {
		display: none
	}
}

@media (max-width:440px)
{
  font-size: 30px;
  font-size:calc(28px + 22 * (50vw + 50vh - 2000px) /2000)

}

.langs .lang.active .label,
.langs .lang:hover .label{
	opacity: 1

}

.langs .lang .label{
	opacity: .5;
	transition: opacity .1s;
	will-change: opacity;
  color:#1d1d1b;
}

.content {
	display: -ms-flexbox;
	display: flex;
	position: absolute;
	top: 0;
	right: 200px;
	bottom: 0;
	left: 65%;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-pack: center;
	justify-content: center;
	padding-top: 20px
}

@media (max-width:1599px)
 {
	.content {
		right: 100px;
		left: 60%
	}
}

@media (max-width:1199px)
 {
   .logo-Intro img
   {
     width:350px;
   }
	.content {
		right: 70px
	}
}
@media (max-width:890px)
 {
   .logo-Intro img
   {
     width:300px;
   }
	.content {
		right: 25px
	}
}
@media (max-width:767px)
{
	.content
  {
		position: relative;
		top: -30px;
		right: auto;
		bottom: auto;
		left: auto;
		padding-top: 65vh;
		padding-left: 150px;
		padding-right: 50px
	}
}

@media (max-width:579px)
{
  .logo-Intro img
  {
    width:200px;
  }
	.content {
		padding-left: 40px;
		padding-right: 40px
	}
}



@media (max-width:440px)
{
	.content {
		padding-left: 50px;
		padding-right: 30px
	}
}

@media (max-width:374px)
{
	.content {
		padding-left: 20px;
		padding-right: 30px
	}
}

.content p {
	margin-bottom: 0
}
</style>

<template>
  <div data-color="clear" class=" u-fixed u-pos-tl u-viewport-fit-h u-bg--brand-dark u-fit-w js-header-panel" >
    <div class="experience">
        <img src="/static/HeadImages/FirstPageImageandanimation-gray3.jpg" class="canvas" />
    </div>
    <div class="o-wrapper--valign u-fit u-pad-r-contact-w3of12" >
      <div class="u-inline-block u-valign-middle logo-Intro">
        <img src="/static/HeadImages/Salameh-Traiteur-contactus.png"  />
      </div>
    </div>
<div class="page-container" style="z-index:10">
<div  class="page-home page">
<div  class="content">
  <div  class="inner">

  <h1 class="title">
     Contact Us
  </h1>

    <!--<app-push-button :visible="isButtonVisible" :isIntro="!0" :active="isButtonActive" :to="{ name: 'aboutmarineholdings'}" :text="uiexplore" >{{uiexplore}}</app-push-button>-->

    <div class="u-fit-w">
       <ul class="o-list u-w2of2" v-for="(postal, index)  in content.postal_addresses"  >
         <li  v-if="postal.address">
           <a href="#" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">

              <span class="t-text--md t-text-lh--md  u-color--black u-inline-block u-valign-middle" v-html="postal.address"></span>
            </a>
          </li>
         <li  v-if="postal.view_on_phone">
           <a href="#" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">

              <span class="t-text--md t-text-lh--md  u-color--black u-inline-block u-valign-middle" v-html="postal.phone_number"></span>
            </a>
          </li>
         <li v-if="postal.view_on_email" class="u-marg-t-xs">
           <a href="#" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">

             <span class="t-text--md t-text-lh--md  u-inline-block u-valign-middle u-color--black"  v-html="postal.email"></span>
           </a>
         </li>
          <!--<li v-if="postal.view_on_map" class="u-marg-t-xs">
            <a :href="_getGoogleMapUrl(postal.map_address)" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">

              <span class="t-text--md u-inline-block u-valign-middle" v-html="content.label_view_on_map"></span>
            </a>
          </li>
          <li v-if="postal.view_on_map" class="u-marg-t-sm shareBtn facebook" style="margin-top:30px" >
            <a href="https://www.facebook.com/ResourceGroupHolding/" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">  </a>
                <a href="https://www.linkedin.com/company/resource-group-holding-sal/" target="_blank" rel="noopener nofollow noreferrer" class="c-contact__section__location__details__map-link u-color--gray">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-680 490 38 38" fill="#000000">
                              <path opacity="0.5" d="M-661,528c-10.486,0-19-8.514-19-19s8.514-19,19-19c10.486,0,19,8.514,19,19S-650.514,528-661,528z M-661,491.443c-9.668,0-17.557,7.889-17.557,17.557c0,9.669,7.889,17.557,17.557,17.557c9.669,0,17.557-7.888,17.557-17.557 C-643.443,499.332-651.332,491.443-661,491.443z"></path>
                              <rect x="-668.937" y="504.671" width="3.463" height="10.968"></rect>
                              <path d="M-656.046,504.526c-1.972,0-3.222,1.059-3.462,1.828v-1.731h-3.897c0.048,0.913,0,10.967,0,10.967h3.897 v-5.916c0-0.338,0-0.674,0.096-0.914c0.289-0.674,0.818-1.348,1.875-1.348c1.347,0,1.973,1.012,1.973,2.502v5.676h3.944v-6.109 C-651.668,506.113-653.592,504.526-656.046,504.526z"></path>
                              <path d="M-667.301,499.476c-1.299,0-2.117,0.817-2.117,1.924c0,1.059,0.818,1.876,2.068,1.876h0.048 c1.299,0,2.116-0.817,2.116-1.924C-665.233,500.293-666.002,499.476-667.301,499.476z"></path>
                          </svg>
                    <span class="t-text--md u-inline-block u-valign-middle  u-marg-l-xs" ></span>
                </a>

          </li>
          <li v-if="postal.view_on_map" class="u-marg-t-xs shareBtn twitter" >

          </li>
          -->
       </ul>
    </div>



         <!--<div  class="description"  :class="{'is-visible':isDescriptionVisible}">
           <p v-html="description" ></p>
         </div>-->
       </div>
     </div>
   </div>
</div>

</div>
</template>
<script>

import AppFooter from '../app-footer/index.vue'
import AppScrollObject from '../app-scroll-object/index.vue'
import AppSlicedText from '../app-sliced-text/index.vue'
export default {
    components: {
      "app-sliced-text":AppSlicedText,
      "app-footer":AppFooter,
      "app-scroll-object":AppScrollObject
    },
    props: {
        adminContent: {
            type: Object,
            default: function() {}
        },
        globalContent: {
            type: Object,
            default: function() {}
        },
        headerPageSize: {
            type: Array,
            default: function() {}
        }
    },
    computed: {
        content: function() {
            return this.adminContent.en.pages.contact

        }
        ,
        myStylesTransform2() {
          return {
              transform: 'translateX('+this.headerPageSize[2]+'px) translateY('+this.headerPageSize[3]+'px) scale('+this.headerPageSize[4]+')'

          }

      },
      myStylesWidthHeight() {
         return {
           width: this.headerPageSize[0] + "px",
           height: this.headerPageSize[1] + "px"

         }
     }
    },
    created: function() {
        this.GOOGLE_API_URL = "https://www.google.com/maps/search/?api=1&query=:address",
            this.onResize = this.onResize.bind(this),
            this.eventHub.$on("resize", this.onResize)
    },
    destroyed: function() {
        this.eventHub.$off("resize", this.onResize)
    },
    mounted: function() {
        this.eventHub.$emit("page:ready"),
        this.onResize()
    },
    data: function() {
        return {

        //  imageHeadSrc:require('../../assets/medias/images/Contact-Header-Rgh.jpg')

        }
      },
    methods: {
        onResize: function() {},
        _getGoogleMapUrl: function(t) {
          return  "https://drive.google.com/open?id=1L0EorG9WxDMEQx055BjFMkFD3yp_E8mE&usp=sharing"
            //return this.GOOGLE_API_URL.replace(":address", encodeURIComponent(t.replace("<br />", " ").replace("\n", "")))
        }
    }
}

</script>
